module.exports = __webpack_public_path__ + "static/media/landingPage_Partner.642fcd23.md";